<label for="status" class="zaya-form-sub-header" i18n="label|The account status of a practitioner.@@labelStatus">Filter by practitioner status</label>
<select class="form-control" (change)="onStatusFilterChanged($event.target.value)">
  <option *ngFor="let status of statuses" [value]="status">
    {{ status }}
  </option>
</select>
